// Persistent dashboard filters + lock state.
//
// Locks survive page reloads; filter values for *locked* sections survive
// navigation back from a Set Detail page, while *unlocked* sections reset
// to the user's saved default (or built-in defaults if no user default
// exists) on a hard mount-from-fresh.
const FILTER_KEY = "brickarb.filter";
const LOCKS_KEY = "brickarb.filter_locks";
const USER_DEFAULT_KEY = "brickarb.filter_default";

export const DEFAULT_LOCKS = {
  toggles: false,  // locks Live Data Only / Hide Not-On-Amazon / Retired / Active / In Stock / Hazmat
  themes: false,   // locks the multi-select theme list
};

export function loadLocks() {
  try {
    const raw = localStorage.getItem(LOCKS_KEY);
    if (!raw) return { ...DEFAULT_LOCKS };
    return { ...DEFAULT_LOCKS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_LOCKS };
  }
}

export function saveLocks(locks) {
  try { localStorage.setItem(LOCKS_KEY, JSON.stringify(locks)); } catch {}
}

export function loadUserDefault() {
  try {
    const raw = localStorage.getItem(USER_DEFAULT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function saveUserDefault(filter) {
  try {
    // Strip volatile fields — search box, sort, page — these shouldn't
    // be part of a "default view" since they change constantly.
    const { search, sort_by, sort_dir, page, page_size, ...keep } = filter;
    localStorage.setItem(USER_DEFAULT_KEY, JSON.stringify(keep));
    return true;
  } catch { return false; }
}

export function clearUserDefault() {
  try { localStorage.removeItem(USER_DEFAULT_KEY); return true; } catch { return false; }
}

export function loadPersistedFilter(builtinDefaults) {
  // Merge order (each layer overrides the previous):
  //   1. built-in defaults (lowest priority)
  //   2. user-saved default
  //   3. locked sections from the most recent filter state
  const userDefault = loadUserDefault();
  const merged = { ...builtinDefaults, ...(userDefault || {}) };

  try {
    const raw = localStorage.getItem(FILTER_KEY);
    if (!raw) return merged;
    const stored = JSON.parse(raw);
    const locks = loadLocks();
    if (locks.toggles) {
      for (const k of TOGGLE_KEYS) {
        if (k in stored) merged[k] = stored[k];
      }
    }
    if (locks.themes && Array.isArray(stored.themes)) {
      merged.themes = stored.themes;
    }
    return merged;
  } catch {
    return merged;
  }
}

export function persistFilter(filter) {
  try {
    localStorage.setItem(FILTER_KEY, JSON.stringify(filter));
  } catch {}
}

export const TOGGLE_KEYS = [
  "live_only",
  "exclude_unlisted",
  "retired_only",
  "active_only",
  "in_stock_only",
  "exclude_hazmat",
];
